import { BASIC_LIGHT_BLUE } from "../constants/colors";

export default function IconHeartSelected() {
  return (
    <svg
      height="20.36"
      viewBox="0 0 23 20.36"
      width="23"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m124.552 172.285 9.473-9.473c2.616-2.616 2.787-7.04 0-9.473-2.325-2.031-6.563-2.239-9.473 1.832-2.91-4.071-7.148-3.863-9.473-1.832-2.787 2.433-2.616 6.857 0 9.473z"
        fill={BASIC_LIGHT_BLUE}
        transform="translate(-113.052 -151.925)"
      />
    </svg>
  );
}
